import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import TitleBar from "../../../../partials/content/TitleBar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import helperTime from "../../../../../helpers/time";
import StatePositionConstant from "./../../StatePositionConstant";
import SetStatePosition from "./../../manage/SetStatePosition";

export default function ViewPosition() {
  const params = useParams();
  const positionID = parseInt(params.positionID);
  const [position, setPosition] = useState();
  const [publisher, setPublisher] = useState();

  useEffect(() => {
    getPosition();
  }, []);

  useEffect(() => {
    if (!position) {
      return;
    }
    getPublisher();
  }, [position]);

  const getPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let publisher = await sendRequestGetPublisher(position.pop_publisher_id);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!publisher) {
      return;
    }
    setPublisher(publisher);
  };

  const sendRequestGetPublisher = async (sitePublisherID) => {
    const headersRequest = getHeaderRequest();
    let position;
    try {
      position = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/manage/publisher/site/${sitePublisherID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return position.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getBadgeTypeClassStatePosition = (statePosition) => {
    let classNameBadgeType;
    switch (statePosition) {
      case StatePositionConstant.statusPosition.PENDING:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition.SEND_SUGGESTION_TO_PUBLISHER:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition.DISAGREE_FROM_PUBLISHER:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition.AGREE_FROM_PUBLISHER:
        classNameBadgeType = "primary";
        break;
      case StatePositionConstant.statusPosition.CONFIRM:
        classNameBadgeType = "success";
        break;

      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_PENDING_FOR_EDIT:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_DISAGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_AGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT:
        classNameBadgeType = "primary";
        break;
    }
    return classNameBadgeType;
  };

  const getPosition = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let position = await sendRequestGetPosition(positionID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!position) {
      return;
    }
    setPosition(position);
  };

  const generateTemporaryDateEditPosition = (positionTemporary) => {
    return (
      <>
        <hr />
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات وارد شده برای ویرایش جایگاه{" "}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>تعداد بنر در جایگاه</td>
                <td>
                  {helpersNumbers.toPersianNum(positionTemporary.ppt_count)}
                </td>
              </tr>
              <tr>
                <td>قیمت پایه جایگاه</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        positionTemporary.ppt_base_price
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>قیمت جایگاه</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        positionTemporary.ppt_price
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>

              <tr>
                <td>نمایش تبلیغ جایگزین</td>
                <td>
                  {positionTemporary.ppt_allow_alternative ? (
                    <span className="badge badge-success">فعال</span>
                  ) : (
                    <span className="badge badge-danger">غیرفعال</span>
                  )}
                </td>
              </tr>

              {positionTemporary.ppt_allow_alternative && (
                <tr>
                  <td>Hicoin تبلیغ بنری جایگزین</td>
                  <td>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          positionTemporary.ppt_score_alternative
                        )
                      )}
                    </span>
                  </td>
                </tr>
              )}
              <tr>
                <td>اندازه جایگاه </td>
                <td>
                  <span className="pl-3">
                    <span>عرض = </span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        positionTemporary.ppt_size.split("-")[0]
                      )}
                    </span>
                    <span>px</span>
                  </span>
                  <span>
                    <span>ارتفاع = </span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        positionTemporary.ppt_size.split("-")[1]
                      )}
                    </span>
                    <span>px</span>
                  </span>
                </td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  {positionTemporary.ppt_active ? (
                    <span className="badge badge-success">فعال</span>
                  ) : (
                    <span className="badge badge-danger">غیرفعال</span>
                  )}
                </td>
              </tr>
              <tr>
                <td>تاریخ درج</td>
                <td>
                  {helpersNumbers.toPersianNum(
                    positionTemporary.ppt_created_at.split(" ")[1] +
                      " " +
                      helperTime.convertGregorianToJalali(
                        positionTemporary.ppt_created_at.split(" ")[0]
                      )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const sendRequestGetPosition = async (positionID) => {
    const headersRequest = getHeaderRequest();
    let position;
    try {
      position = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/manage/publisher/position/${positionID}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return position.data.data;
  };

  const generatePublisher = () => {
    return (
      <>
        <div>
          <div className="pb-2">
            <span>
              عکس آپلود شده توسط کاربر برای جایگاه های مستقل سایت{" "}
              <a href={publisher.usp_url} target="_blank">
                {publisher.usp_url}
              </a>
            </span>
          </div>
          <div>
            <a target="_blank" href={publisher.image_url}>
              <img class="img-fluid" src={publisher.image_url} />
            </a>
          </div>
        </div>
      </>
    );
  };

  const generatePositionInfo = () => {
    return (
      <>
        <div className="table-responsive ">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  <b>اطلاعات جایگاه</b>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره جایگاه</td>
                <td>{helpersNumbers.toPersianNum(position.pop_id)}</td>
              </tr>
              <tr>
                <td>تعداد بنر در جایگاه</td>
                <td>{helpersNumbers.toPersianNum(position.pop_count)}</td>
              </tr>
              <tr>
                <td>قیمت پایه جایگاه</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        position.pop_base_price
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>قیمت جایگاه</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(position.pop_price)
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>حق نمایش دهنده</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        position.pop_publisher_right
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>
              <tr>
                <td>کمسیسون هایلات</td>
                <td>
                  <span className="letter-spacing-finance-number">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(
                        position.pop_hilite_commission
                      )
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </td>
              </tr>

              <tr>
                <td>نمایش تبلیغ جایگزین</td>
                <td>
                  {position.pop_allow_alternative ? (
                    <span className="badge badge-success">فعال</span>
                  ) : (
                    <span className="badge badge-danger">غیرفعال</span>
                  )}
                </td>
              </tr>

              {position.pop_allow_alternative && (
                <tr>
                  <td>Hicoin تبلیغ بنری جایگزین</td>
                  <td>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          position.pop_score_alternative
                        )
                      )}
                    </span>
                  </td>
                </tr>
              )}
              <tr>
                <td>اندازه جایگاه </td>
                <td>
                  <span className="pl-3">
                    <span>عرض = </span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        position.pop_size.split("-")[0]
                      )}
                    </span>
                    <span>px</span>
                  </span>
                  <span>
                    <span>ارتفاع = </span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        position.pop_size.split("-")[1]
                      )}
                    </span>
                    <span>px</span>
                  </span>
                </td>
              </tr>

              <tr>
                <td>وضعیت</td>
                <td>
                  {position.pop_active ? (
                    <span className="badge badge-success">فعال</span>
                  ) : (
                    <span className="badge badge-danger">غیرفعال</span>
                  )}
                </td>
              </tr>
              <tr>
                <td>حالت</td>
                <td>
                  <span
                    className={`badge badge-${getBadgeTypeClassStatePosition(
                      position.pop_state
                    )}`}
                  >
                    {
                      StatePositionConstant.getStatusPositionString()[
                        position.pop_state
                      ]
                    }
                  </span>
                </td>
              </tr>
              <tr>
                <td> آخرین پیغام ارسال شده به کاربر از طرف اپراتور</td>
                <td>
                  <p
                    className="text-justify"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {position.pop_message}
                  </p>
                </td>
              </tr>
              <tr>
                <td>تگ html جایگاه </td>
                <td></td>
              </tr>
              <tr>
                <td>تاریخ درج</td>
                <td>
                  {helpersNumbers.toPersianNum(
                    position.pop_created_at.split(" ")[1] +
                      " " +
                      helperTime.convertGregorianToJalali(
                        position.pop_created_at.split(" ")[0]
                      )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="pt-2">
          <Link
            className="btn btn-primary"
            to={`/position/manage/independent/${positionID}/all-message`}
          >
            نمایش پیغام های رد بدل شده
          </Link>
        </div>
        <hr />
        {publisher && generatePublisher()}
        <div>
          {position["temporary"] &&
            generateTemporaryDateEditPosition(position["temporary"])}
        </div>
        <SetStatePosition position={position} />
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar
          title={` تعیین وضعیت جایگاه مستقل سایت  ${
            publisher && publisher.usp_url.replace("https://", "")
          } `}
        />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to={`/position/manage/independent/publisher/${position?.pop_publisher_id}`}
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>

              {position && generatePositionInfo()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
